// Datos del wizard de onboarding: giros de negocio, modo sugerido y
// plantillas de primera recompensa (1 clic, editables).
// Regla de oro (manual): ticket bajo/uniforme → puntos; ticket variable/alto → cashback.
// Imágenes stock de recompensa servidas desde api.lealify.com/uploads (uploader-api),
// el MISMO host que el resto de imágenes de recompensa. Migrado de esapi el 30-jun-2026
// (Fase 2 descomiso esapi): el imageUrl se PERSISTE como rewards.image_url al completar
// el onboarding (OnboardingWizardPage:99), por eso necesita URL absoluta y estable (no
// un asset con hash de bundle). Los 6 SVGs (barber/cafe/gift/restaurant/shop/spa) viven en
// /home/lealify/uploader-api/uploads/.
const ASSET_BASE = 'https://api.lealify.com/uploads';

export type LoyaltyMode = 'visits' | 'cashback';

export interface RewardTemplate {
  title: string;
  description: string;
  /** Costo en el modo puntos, expresado en VISITAS (se multiplica por pointsPerVisit). */
  visitsCost: number;
  /** Costo en el modo cashback, expresado en pesos. */
  cashbackCost: number;
  imageUrl: string;
}

export interface BusinessCategory {
  id: string;
  label: string;
  emoji: string;
  suggestedMode: LoyaltyMode;
  /** Valor sugerido: puntos por visita (visits) y % (cashback). */
  suggestedPointsPerVisit: number;
  suggestedCashbackPct: number;
  templates: RewardTemplate[];
}

export const CATEGORIES: BusinessCategory[] = [
  {
    id: 'cafe', label: 'Cafetería', emoji: '☕',
    suggestedMode: 'visits', suggestedPointsPerVisit: 1, suggestedCashbackPct: 10,
    templates: [
      { title: 'Bebida gratis', description: 'Cualquier bebida del menú, cortesía de la casa', visitsCost: 10, cashbackCost: 60, imageUrl: `${ASSET_BASE}/cafe.svg` },
      { title: 'Postre gratis', description: 'El postre que elijas para acompañar tu visita', visitsCost: 6, cashbackCost: 50, imageUrl: `${ASSET_BASE}/gift.svg` },
    ],
  },
  {
    id: 'barber', label: 'Barbería / Salón', emoji: '💈',
    suggestedMode: 'visits', suggestedPointsPerVisit: 1, suggestedCashbackPct: 10,
    templates: [
      { title: 'Corte gratis', description: 'Tu corte de siempre, va por nuestra cuenta', visitsCost: 6, cashbackCost: 150, imageUrl: `${ASSET_BASE}/barber.svg` },
      { title: '50% en tu servicio', description: 'Mitad de precio en el servicio que elijas', visitsCost: 4, cashbackCost: 80, imageUrl: `${ASSET_BASE}/gift.svg` },
    ],
  },
  {
    id: 'restaurant', label: 'Restaurante', emoji: '🍽️',
    suggestedMode: 'cashback', suggestedPointsPerVisit: 1, suggestedCashbackPct: 10,
    templates: [
      { title: '$100 de descuento', description: 'Aplícalo en tu siguiente consumo', visitsCost: 8, cashbackCost: 100, imageUrl: `${ASSET_BASE}/restaurant.svg` },
      { title: 'Entrada gratis', description: 'La entrada que elijas para empezar', visitsCost: 5, cashbackCost: 70, imageUrl: `${ASSET_BASE}/gift.svg` },
    ],
  },
  {
    id: 'spa', label: 'Spa / Estética', emoji: '💆',
    suggestedMode: 'cashback', suggestedPointsPerVisit: 1, suggestedCashbackPct: 10,
    templates: [
      { title: 'Facial express gratis', description: 'Un facial express de regalo en tu visita', visitsCost: 5, cashbackCost: 200, imageUrl: `${ASSET_BASE}/spa.svg` },
      { title: '$150 de descuento', description: 'En el tratamiento que prefieras', visitsCost: 4, cashbackCost: 150, imageUrl: `${ASSET_BASE}/gift.svg` },
    ],
  },
  {
    id: 'shop', label: 'Tienda / Boutique', emoji: '🛍️',
    suggestedMode: 'cashback', suggestedPointsPerVisit: 1, suggestedCashbackPct: 10,
    templates: [
      { title: '$150 de descuento', description: 'Úsalo en tu siguiente compra', visitsCost: 6, cashbackCost: 150, imageUrl: `${ASSET_BASE}/shop.svg` },
      { title: 'Artículo sorpresa', description: 'Un detalle de regalo al canjear', visitsCost: 5, cashbackCost: 100, imageUrl: `${ASSET_BASE}/gift.svg` },
    ],
  },
  {
    id: 'other', label: 'Otro', emoji: '✨',
    suggestedMode: 'visits', suggestedPointsPerVisit: 1, suggestedCashbackPct: 10,
    templates: [
      { title: 'Premio sorpresa', description: 'Un detalle especial por tu preferencia', visitsCost: 10, cashbackCost: 100, imageUrl: `${ASSET_BASE}/gift.svg` },
      { title: '10% de descuento', description: 'En tu siguiente compra o servicio', visitsCost: 5, cashbackCost: 60, imageUrl: `${ASSET_BASE}/gift.svg` },
    ],
  },
];

export const CASHBACK_PRESETS = [5, 10, 15];
export const POINTS_PRESETS = [1, 5, 10];

export function getCategory(id: string | null | undefined): BusinessCategory {
  return CATEGORIES.find(c => c.id === id) || CATEGORIES[CATEGORIES.length - 1];
}
